import { render, staticRenderFns } from "./HeadersPreview.vue?vue&type=template&id=220ee630&scoped=true"
import script from "./HeadersPreview.vue?vue&type=script&lang=js"
export * from "./HeadersPreview.vue?vue&type=script&lang=js"
import style0 from "./HeadersPreview.vue?vue&type=style&index=0&id=220ee630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220ee630",
  null
  
)

export default component.exports